//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import ClockImage from '../../../../static/images/svg/clock-light.svg';

export default {
  name: 'PDPTimer',
  props: {
    date: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      parsedDate: Date.parse((new Date()).toISOString()),
      currentTime: {
        total: 0,
        days: 0,
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
      clockImageSrc: ClockImage,
      refreshTimeoutInstance: null,
    };
  },
  computed: {
    endDateString() {
      const dayjsDate = dayjs(this.date);
      const ordinalDay = this.getOrdinalNum(dayjsDate.date());
      return dayjsDate.format(`[Ends on] MMMM [${ordinalDay}] [at] h:mma`);
    },
  },
  created() {
    // Use native javascript to parse dates, if issue use day.js
    try {
      this.parsedDate = Date.parse(new Date(this.date).toISOString());
    } catch (error) {
      // Cannot parse date
    }
  },
  mounted() {
    setTimeout(this.countdown, 1);

    this.setRefreshTimeout();
  },
  beforeDestroy() {
    if (this.refreshTimeoutInstance) {
      clearTimeout(this.refreshTimeoutInstance);
    }
  },
  methods: {
    setRefreshTimeout() {
      const dayjsDate = dayjs(this.date);
      const dayjsNow = dayjs();
      const diffInMilliseconds = dayjsDate.diff(dayjsNow);

      // '$nuxt.refresh' will fire any fetch() or data() found in any parent level
      this.refreshTimeoutInstance = setTimeout(this.$nuxt.refresh, diffInMilliseconds);
    },
    getOrdinalNum(n) {
      // jl: return ordinal string of n
      //     e.g. (n=2) => '2nd', (n=3) => '3rd'

      const ordinalRules = new Intl.PluralRules('en-US', { type: 'ordinal' });
      const suffixes = new Map([
        ['one', 'st'],
        ['two', 'nd'],
        ['few', 'rd'],
        ['other', 'th'],
      ]);
      const rule = ordinalRules.select(n);
      const suffix = suffixes.get(rule);

      return `${n}${suffix}`;
    },
    formatTime(value) {
      return `0${value}`.slice(-2);
    },
    countdown() {
      const t = this.parsedDate - Date.parse((new Date()).toISOString());

      if (t < 0) return;

      const seconds = Math.floor((t % (1000 * 60)) / 1000);
      const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
      let hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let days = Math.floor(t / (1000 * 60 * 60 * 24));

      // convert the last day into hours
      if (days === 1) {
        days = 0;
        hours += 24;
      }

      if (t > 0) {
        this.currentTime = {
          total: t,
          days,
          daysStr: this.formatTime(days),
          hours: this.formatTime(hours),
          minutes: this.formatTime(minutes),
          seconds: this.formatTime(seconds),
        };

        setTimeout(this.countdown, 1000);
      } else {
        this.currentTime = {
          total: 0,
          days: 0,
          hours: '00',
          minutes: '00',
          seconds: '00',
        };
      }
    },
  },
};
